// 封装的vuex仓库文件
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  // 定义状态的默认值  通过：this.$store.state.xxx 来调用
  state() {
    return {
      role: [], // 用户权限字符集
    };
  },
  // store 的计算属性，对 state 的加工，是派生出来的数据  通过：this.$store.getters.xxx 来调用
  getters: {
    role(state) {
      return state.role;
    },
  },
  // 改变数据的方法集合， 通过：this.$store.commit('xxx') 来调用
  mutations: {
    SET_ROLE(state, value) {
      state.role = value;
    },
  },
  // 异步操作的集合，通过：this.$store.dispatch('xxx') 来调用
  actions: {},
});

export default store;
